<template>
  <div class="pt-4 pb-5 h-auto">
    <div class="container-fluid cadastroNaoAssociado">
      <div
        class="d-flex flex-column justify-content-between align-items-stretch"
      >
        <div class="row">
          <div
            class="col-12 p-3 d-flex justify-content-center align-content-center"
          >
            <img
              src="@/assets/img/logo_60_p.svg"
              class="img-fluid"
              alt="logo"
              width="180"
            />
          </div>
        </div>
        <div class="row">
          <div class="col form_padrao">
            <h5 class="pb-4 text-uppercase text-center">
              Cadastre-se como não associado
            </h5>
            <div>
              <FormulateForm
                name="Cadastro"
                v-model="values"
                @submit="salvarRegistro"
              >
                <div class="row">
                  <div class="col-md-8">
                    <FormulateInput
                      type="text"
                      name="nomefantasia"
                      label="Nome Comercial"
                      validation="required"
                    />
                  </div>
                  <div class="col-md-4">
                    <FormulateInput
                      type="select"
                      name="tp_empresa"
                      :options="tipoEmpresa"
                      label="Tipo Empresa"
                      validation="required"
                    />
                  </div>
                </div>
                <FormulateInput
                  type="text"
                  name="nome"
                  label="Razão Social"
                  validation="required"
                />
                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="cgccfo"
                      label="CPF/CPNJ"
                      validation="required"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      @change="validarCpf($event.target.value)"
                    />
                  </div>
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="inscrestadual"
                      label="Inscrição Estadual"
                    />
                  </div>
                </div>
                <Endereco ref="enderecoRef" />
                <div class="form-row mt-5">
                  <div class="col">
                    <p class="text-uppercase font-12 fw-600">
                      dados do sócio proprietário
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <FormulateInput
                      type="text"
                      name="contato"
                      label="Nome do Sócio Proprietário"
                      validation="required"
                    />
                  </div>
                  <div class="col-md-4">
                    <FormulateInput
                      type="text"
                      name="cpf"
                      label="CPF"
                      validation="required"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      @change="validarCpf($event.target.value)"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="select"
                      name="sexo"
                      :options="tipoSexo"
                      label="Sexo"
                      validation="required"
                    />
                  </div>
                  <div class="col-md-6">
                    <FormulateInput
                      type="date"
                      name="datanascimento"
                      label="Data Nascimento"
                      validation="required"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="celular"
                      label="Celular"
                      validation="required"
                      v-mask="'(##) #####-####'"
                    />
                  </div>
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="telefone"
                      label="Telefone"
                      v-mask="'(##) ####-####'"
                    />
                  </div>
                </div>
                <FormulateInput
                  type="email"
                  name="email"
                  label="Email"
                  validation="required|email"
                />
                <div
                  class="form-check d-flex pl-2 pb-2 mt-3 align-items-center"
                >
                  <input
                    type="checkbox"
                    id="ciente"
                    name="ciente"
                    v-model="aceiteTermo"
                  /><label for="ciente" class="small pt-2"
                    >Aceito os
                    <a
                      href="https://www.cdlbh.com.br/politica-de-privacidade/"
                      target="_blank"
                      >termos de uso e política de privacidade</a
                    ></label
                  >
                </div>
                <div class="d-flex col-5">
                  <button
                    type="submit"
                    class="btn btn-verde p-0"
                    :disabled="loading"
                  >
                    <span
                      class="spinner-grow spinner-grow-sm pr-2"
                      role="status"
                      aria-hidden="true"
                      v-show="loading"
                    ></span>
                    <span v-if="loading">Aguarde</span>
                    <span v-else>Salvar</span>
                  </button>
                </div>
              </FormulateForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clearStr, validateCPF } from "../../helpers";
import Endereco from "@/components/cadastro/FormEndereco";
export default {
  name: "Login",
  components: { Endereco },
  data() {
    return {
      tipoEmpresa: [
        {
          label: "Selecione",
          value: "",
        },
        {
          label: "Pessoa Jurídica",
          value: "PJ",
        },
        {
          label: "Associação ou Entidade",
          value: "AE",
        },
        {
          label: "Profissional Liberal",
          value: "PL",
        },
        {
          label: "Autônomo",
          value: "AUT",
        },
        {
          label: "MEI",
          value: "MEI",
        },
      ],
      tipoSexo: [
        {
          label: "Selecione",
          value: "",
        },
        {
          label: "Masculino",
          value: "M",
        },
        {
          label: "Feminino",
          value: "F",
        },
      ],
      values: {},
      loading: false,
      error: false,
      aceiteTermo: false,
    };
  },

  methods: {
    validarCpf(cpfStr) {
      var cpf = clearStr(cpfStr);

      const result = validateCPF(cpf);
      if (!result) {
        this.invalidCpf = true;
        this.$formulate.handle(
          {
            inputErrors: { cpf: "CPF Inválido!" },
            hasErrors: { cpf: true },
          },
          "Cadastro"
        );
      } else {
        this.invalidCpf = false;
        this.$formulate.handle({ inputErrors: { cpf: null } }, "Cadastro");
      }
    },
    async salvarRegistro() {
      this.loading = true;
      var dadosForm = Object.assign({}, this.values);
      const auth = {
        UserName: "apicdl",
        Password: "6a85@e69b7c944ce38ed0c60cfc8a",
      };
      await this.$http
        .post("/Login", auth)
        .then((response) => {
          window.sessionStorage.token = `Bearer ${response.data.token}`;
        })
        .catch((error) => {
          window.sessionStorage.token = null;
          console.log(error);
        });

      if (window.sessionStorage.token) {
        if (!sessionStorage.ip) {
          await fetch(process.env.VUE_APP_IP_API + "?format=json")
            .then((x) => x.json())
            .then(({ ip }) => {
              sessionStorage.ip = ip;
            });
        }

        dadosForm.cgccfo = clearStr(dadosForm.cgccfo);
        dadosForm.cep = clearStr(dadosForm.cep);
        dadosForm.telefone = dadosForm.telefone
          ? clearStr(dadosForm.telefone)
          : "";
        dadosForm.celular = clearStr(dadosForm.celular);
        dadosForm.cpf = clearStr(dadosForm.cpf);

        if (!dadosForm.inscrestadual) {
          dadosForm.inscrestadual = "ISENTO";
        }

        const valuesFixos = {
          codcoligada: 0,
          formapgto: "C",
          codcfo: "-1",
          codcoltcf: "1",
          ativo: 0,
          pagrec: 3,
          pessoafisoujur:
            dadosForm.tp_empresa == "PL" || dadosForm.tp_empresa == "AUT"
              ? "f"
              : "j",
          IPORIGEM: sessionStorage.ip,
          codtcf: "000011",
          CNPJ: dadosForm.cgccfo,
          codetd: dadosForm.estado,
          codpacote: "0000283",
        };

        if (dadosForm.numero) {
          dadosForm.numero = parseInt(dadosForm.numero);
        }
        if (dadosForm.celular) {
          dadosForm.celular = parseInt(dadosForm.celular.substr(2));
        }

        const dados = { ...valuesFixos, ...dadosForm };

        await this.$http
          .post("/api/Totvs/InserirCadastroAssociado", dados)
          .then((response) => {
            if (response.data.sucesso) {
              this.$toast.open({
                message: "Cadastro realizado com sucesso. Verifique seu email.",
                type: "success",
                duration: 4000,
              });
              this.$router.push({ name: "login" });
            } else {
              this.loading = false;
              this.$toast.open({
                message: response.data.mensagem,
                type: "error",
                duration: 4000,
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$toast.open({
              message: error.data.mensagem,
              type: "error",
            });
          });
        this.error = false;
      }
    },
  },
  created() {
    document.title = "CDL/BH - Cadastro de Usuário não associado!";
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
@import "@/assets/scss/_vars.scss";
.cadastroNaoAssociado /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  background: white;
  padding: 2rem;
  max-width: 900px;
  margin: 0 auto;
  border-radius: 6px;
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }

    .formulate-input-element {
      padding: 5px;
      background: $dark-100;
      input,
      select {
        background: $dark-100;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
        height: 100%;
      }
    }
    &[data-classification="button"] {
      &,
      .formulate-input-element {
        padding: 0;
        background-color: transparent;
      }
      button {
        padding-left: 1.4rem;
        padding-right: 1.4rem;
      }
    }
  }
}
.visibility {
  position: absolute;
  right: 10px;
  top: 20px;
  font-size: 1rem;
  cursor: pointer;
}
</style>
